import { Dictionary } from "../config";
class I18n {
  locale: any;
  lang: string = "en";

  setLocale = (locale: Dictionary<any>) => {
    this.locale = locale;
  };

  t = (key: string) => {
    // get the text from locale or the [key]
    console.log("locale", this.locale);
    const loca = this.locale; //store.getState().app.locale;
    if (loca) {
      const v = loca[key];
      return v || "[" + key + "]";
    }
  };

  setLang = (lang: string) => {
    this.lang = lang;
  };
}

export default new I18n();
